// Lifted's browser ID, sent with createSubscriptionIntent so Lifted can tie
// the subscription to a visit (see apps/web/utils/lifted.ts).
//
// The script is async, so the paywall can create a checkout before it has
// run, and ad-blockers stop it entirely. The script keeps its ID in
// localStorage "lifted_visitor" and reuses one that is already there, so
// read that, and if there is none yet, make it: the script picks it up when
// it loads, and Lifted still counts a blocked visitor's checkout.
const KEY = "lifted_visitor";

const newId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : String(Math.random()).slice(2) + Date.now();

export function liftedVisitor(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const fromScript = (window as unknown as { lifted?: { visitor?: string } })
    .lifted?.visitor;
  if (fromScript) return fromScript;
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = newId();
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
}
